module.exports = __webpack_public_path__ + "img/pv_item.51245571.svg";